// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1gBNr","author":"Table_author__3O9QC","authorImage":"Table_authorImage__1VdYb","unreadRow":"Table_unreadRow__3xZsN"};